'use client';

/**
 * Single client boundary for shell content. SlotsProvider is at app root (SlotsProviderRoot)
 * so all route children share the same context. Renders TopBarCenterContentProvider > DrawerExtraProvider > ShellBody > children.
 */

import { DrawerExtraProvider } from '@korvo/core/components/shared/TopBar/DrawerExtraContext';
import type { ReactNode } from 'react';

import { ShellBody } from './ShellBody';
import { TopBarCenterContentProvider } from './TopBarCenterContentContext';

export type ShellContentClientProps = {
  children: ReactNode;
  topBar: ReactNode;
  footer?: ReactNode;
  showOnEditorPaths?: boolean;
  hideOnPathPrefixes?: string[];
  showOnPathPrefixesOnlyWhenMobile?: string[];
  showOnMobileForPathPrefixes?: string[];
};

export function ShellContentClient({
  children,
  topBar,
  footer,
  showOnEditorPaths,
  hideOnPathPrefixes,
  showOnPathPrefixesOnlyWhenMobile,
  showOnMobileForPathPrefixes,
}: ShellContentClientProps) {
  return (
    <TopBarCenterContentProvider>
      <DrawerExtraProvider>
        <ShellBody
          topBar={topBar}
          footer={footer}
          showOnEditorPaths={showOnEditorPaths}
          hideOnPathPrefixes={hideOnPathPrefixes}
          showOnPathPrefixesOnlyWhenMobile={showOnPathPrefixesOnlyWhenMobile}
          showOnMobileForPathPrefixes={showOnMobileForPathPrefixes}
        >
          {children}
        </ShellBody>
      </DrawerExtraProvider>
    </TopBarCenterContentProvider>
  );
}
